import MobileTabsHeader from 'components/TabsHeader/MobileTabsHeader';
import { usePerms } from 'contexts/PermsContext';
import ForecastAdvisories from 'features/Weather/features/WeatherAlerts/features/ForecastAdvisories/index.web';
import Hurricanes from 'features/Weather/features/WeatherMaps/features/Hurricanes/index.web.jsx';
import SevereWeatherAlerts from 'features/Weather/features/WeatherMaps/features/SevereWeatherAlerts/index.web';
import { useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { useNavigate, useSearchParams } from 'react-router-dom';
import TabsHeader from '../../components/TabsHeader/TabsHeader';

export default function StormCenter() {
  const [params] = useSearchParams();

  const perms = usePerms();
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      if (!(await perms.validatePermissions(['StormCenterEnabled']))) {
        navigate('/404');
        return;
      }
    })();
  }, []);

  const renderTab = () => {
    switch (params.get('tab')?.toLowerCase()) {
      case 'nws alerts':
        return (
          <div className="scrollbar-hidden h-100 overflow-auto">
            <ForecastAdvisories title="Current NWS Alerts" />
          </div>
        );
      case 'my forecast advisories':
        return (
          <div className="scrollbar-hidden h-100 overflow-auto">
            <ForecastAdvisories title="My Forecast Advisories" localOnly={true} />
          </div>
        );
      case 'advisories map':
        return <SevereWeatherAlerts />;
      case 'hurricanes and tropical storms':
        return <Hurricanes />;
      default:
        return (
          <div className="scrollbar-hidden h-100 overflow-auto">
            <ForecastAdvisories title="Current NWS Alerts" />
          </div>
        );
    }
  };

  return (
    <Container fluid className="d-flex h-100 min-h-0 flex-column overflow-hidden py-3">
      {/* header */}
      <div className="d-none d-lg-block">
        <TabsHeader
          options={[
            { option: 'NWS Alerts' },
            { option: 'My Forecast Advisories' },
            { option: 'Advisories Map' },
            { option: 'Hurricanes and Tropical Storms' },
          ]}
          styles={[{ backgroundColor: '#436c98' }]}
        />
      </div>
      <div className="d-block d-lg-none">
        <MobileTabsHeader
          options={[
            { option: 'NWS Alerts' },
            { option: 'My Forecast Advisories' },
            { option: 'Advisories Map' },
            { option: 'Hurricanes and Tropical Storms' },
          ]}
          styles={[{ backgroundColor: '#436c98' }]}
        />
      </div>
      <div className="min-h-0 w-100 flex-grow-1 overflow-auto">{renderTab()}</div>
    </Container>
  );
}
